import React from 'react';
import ReactDOM from 'react-dom';
import PrematchProWidget from '../../data/widgets/PrematchPro';
import { useState } from 'react';

function createContainer() {
    const div = document.createElement('div');
    div.classList.add('xs-popup-backdrop');
    document.body.append(div);
}

function destroyContainer() {
    document.querySelector('.xs-popup-backdrop').remove();
}

export default function PrematchProToggle(props) {
    const [toggled, setToggled] = useState(false);

    function toggle() {
        if (toggled) {
            setToggled(false);
            destroyContainer();
        } else {
            createContainer();
            setToggled(true);
        }
    }

    const container = document.querySelector('.xs-popup-backdrop');
    
    return (
        <>
            <i className={props.className} onClick={toggle} />
            {toggled && ReactDOM.createPortal(
                <div className="xs-popup-container">
                    <div className="xs-popup-header">
                        <i className="fa fa-times pointer" onClick={toggle} />
                    </div>
                    <div className="xs-popup-content">
                        <PrematchProWidget id={props.id} />
                    </div>
                </div>
                , container
            )}
        </>
    );
}
